<template>
    <div>
        <div v-if="loading">
            <widget-loading></widget-loading>
        </div>
        <div v-else>
            <div class="create-prem-block">
                <div class="block-h2">{{ Lang.get('js.create-warehouse.block-h2') }}</div>
                <div class="row position-relative">
                    <div class="settings-content col-12">
                        <div>
                            <el-radio v-for="item in premiseTypeOptions" v-model="form.premise_type"
                                      :key="item.id" :value="item.value" :label="item.value" >{{item.value}}</el-radio>
                            <div class="form-group">
                                <label class="label-item">{{ Lang.get('js.create-warehouse.name') }}<span
                                        class="text-danger h4">*</span></label>
                                <input type="text"
                                       class="form-control"
                                       :placeholder="Lang.get('js.create-warehouse.name')"
                                       name="name"
                                       v-model="form.name"
                                       @input="clearFormErrors('name')">
                                <span class="text-danger"
                                      v-if="form.errors.has('name')"
                                      v-text="form.errors.get('name')">
    </span>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-6">
                                    <label class="label-item">{{ Lang.get('js.create-warehouse.type') }}<span
                                            class="text-danger h4">*</span></label>
                                    <el-select v-model="form.types"
                                               @change="clearFormErrors('types')"
                                               clearable
                                               multiple
                                               :placeholder="selectPlaceholder">
                                        <el-option
                                                v-for="cat in preparedPremiseTypes"
                                                :key="cat.id"
                                                :label="cat.name"
                                                :value="cat.id">
                                        </el-option>
                                    </el-select>
                                    <span class="text-danger"
                                          v-if="form.errors.has('types')"
                                          v-text="form.errors.get('types')">
    </span>
                                </div>
                                <div class="form-group col-6">
                                    <label class="label-item">{{ Lang.get('js.create-warehouse.status') }}<span
                                            class="text-danger h4">*</span></label>
                                    <el-select v-model="form.statuses"
                                               @change="clearFormErrors('statuses')"
                                               clearable
                                               multiple
                                               :placeholder="statusPlaceholder">
                                        <el-option
                                                v-for="status in preparedPremiseStatuses"
                                                :key="status.id"
                                                :label="status.name"
                                                :value="status.id">
                                        </el-option>
                                    </el-select>
                                    <span class="text-danger"
                                          v-if="form.errors.has('statuses')"
                                          v-text="form.errors.get('statuses')">
    </span>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col">
                                    <label class="label-item">{{ Lang.get('js.create-warehouse.square') }}, м<sup>2</sup><span
                                            class="text-danger h4">*</span></label>
                                    <input type="number"
                                           class="form-control"
                                           :placeholder="Lang.get('js.create-warehouse.square')"
                                           name="area"
                                           v-model="form.area"
                                           @input="clearFormErrors('area')">
                                    <span class="text-danger"
                                          v-if="form.errors.has('area')"
                                          v-text="form.errors.get('area')">
    </span>
                                </div>
                                <div class="form-group">
                                    <label class="label-item">{{ Lang.get('js.create-warehouse.floor') }}<span
                                            class="text-danger h4">*</span></label>
                                    <input type="text"
                                           class="form-control"
                                           :placeholder="Lang.get('js.create-warehouse.floor')"
                                           name="name"
                                           v-model="form.floor"
                                           @input="clearFormErrors('floor')">
                                    <span class="text-danger"
                                          v-if="form.errors.has('floor')"
                                          v-text="form.errors.get('floor')">
    </span>
                                </div>
                                <div class="form-group">
                                    <label class="label-item">{{ Lang.get('js.create-warehouse.floor_number') }}<span
                                            class="text-danger h4">*</span></label>
                                    <input type="text"
                                           class="form-control"
                                           :placeholder="Lang.get('js.create-warehouse.floor_number')"
                                           name="name"
                                           v-model="form.floor_number"
                                           @input="clearFormErrors('floor_number')">
                                    <span class="text-danger"
                                          v-if="form.errors.has('floor_number')"
                                          v-text="form.errors.get('floor_number')">
    </span>
                                </div>
                                <div class="form-group col-6">
                                    <label class="label-item">{{ Lang.get('js.create-warehouse.bathroom') }}<span
                                            class="text-danger h4">*</span></label>
                                    <el-select v-model="form.bathroom"
                                               @change="clearFormErrors('bathroom')"
                                               clearable
                                               :placeholder="selectPlaceholder">
                                        <el-option
                                                v-for="cat in preparedBathroomTypes"
                                                :key="cat.id"
                                                :label="cat.name"
                                                :value="cat.name">
                                        </el-option>
                                    </el-select>
                                    <span class="text-danger"
                                          v-if="form.errors.has('bathroom')"
                                          v-text="form.errors.get('bathroom')">
    </span>
                                </div>
                                <div class="form-group col-6">
                                    <label class="label-item">{{ Lang.get('js.create-warehouse.heating') }}<span
                                            class="text-danger h4">*</span></label>
                                    <el-select v-model="form.heating"
                                               @change="clearFormErrors('heating')"
                                               clearable
                                               :placeholder="selectPlaceholder">
                                        <el-option
                                                v-for="cat in preparedHeatingTypes"
                                                :key="cat.id"
                                                :label="cat.name"
                                                :value="cat.name">
                                        </el-option>
                                    </el-select>
                                    <span class="text-danger"
                                          v-if="form.errors.has('heating')"
                                          v-text="form.errors.get('heating')">
    </span>
                                </div>
                                <div class="row">
                                    <div class="col-12 form-group">
                                        <label class="font-weight-bold">{{ Lang.get('js.create-warehouse.communications') }}</label>
                                        <br>


                                        <el-checkbox v-model="form.gas">{{ Lang.get('js.create-warehouse.gas') }}</el-checkbox>
                                        <el-checkbox v-model="form.central_water_supply">{{ Lang.get('js.create-warehouse.central_water_supply') }}</el-checkbox>
                                        <el-checkbox v-model="form.well">{{ Lang.get('js.create-warehouse.well') }}</el-checkbox>
                                        <el-checkbox v-model="form.electricity">{{ Lang.get('js.create-warehouse.electricity') }}</el-checkbox>
                                        <el-checkbox v-model="form.central_sewage_system">{{ Lang.get('js.create-warehouse.central_sewage_system') }}</el-checkbox>
                                        <el-checkbox v-model="form.sewerage_septic_tank">{{ Lang.get('js.create-warehouse.sewerage_septic_tank') }}</el-checkbox>
                                        <el-checkbox v-model="form.waste_collection">{{ Lang.get('js.create-warehouse.waste_collection') }}</el-checkbox>
                                        <el-checkbox v-model="form.asphalt_road">{{ Lang.get('js.create-warehouse.asphalt_road') }}</el-checkbox>
                                        <el-checkbox v-model="form.no_communicatio">{{ Lang.get('js.create-warehouse.no_communicatio') }}</el-checkbox>

                                        <span class="text-danger"
                                              v-if="form.errors.has('complect')"
                                              v-text="form.errors.get('complect')">
                        </span>
                                    </div>
                                </div>
                                <div class="form-group col">
                                    <label class="label-item">{{ Lang.get('js.create-warehouse.price') }}<span class="text-danger h4">*</span></label>
                                    <input type="number"
                                           class="form-control"
                                           :placeholder="Lang.get('js.create-warehouse.price')"
                                           name="price"
                                           v-model="form.price"
                                           @input="clearFormErrors('price')">
                                    <span class="text-danger"
                                          v-if="form.errors.has('price')"
                                          v-text="form.errors.get('price')">
    </span>
                                </div>
                                <div class="form-group col">
                                    <label class="label-item">{{ Lang.get('js.create-warehouse.razmerost') }}<span
                                            class="text-danger h4">*</span></label>
                                    <input type="text"
                                           class="form-control"
                                           :placeholder="Lang.get('js.create-warehouse.example')"
                                           name="measure"
                                           v-model="form.measure"
                                           @input="clearFormErrors('measure')">
                                    <span class="text-danger"
                                          v-if="form.errors.has('measure')"
                                          v-text="form.errors.get('measure')">
    </span>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="label-item">{{ Lang.get('js.create-warehouse.station') }}<span
                                        class="text-danger h4">*</span></label>
                                <el-select v-model="form.station" :placeholder="Lang.get('js.create-warehouse.station_placeholder')">
                                    <el-option
                                            v-for="item in preparedStationTypes"
                                            :key="item.id"
                                            :label="Lang.locale == 'ua' ? item.name_ua : item.name_ru"
                                            :value="item.id"
                                            @input="clearFormErrors('station')">
                                    </el-option>
                                </el-select>
                                <span class="text-danger"
                                      v-if="form.errors.has('station')"
                                      v-text="form.errors.get('station')">
    </span>
                            </div>
                            <div class="form-group">
                                <label class="label-item">{{ Lang.get('js.create-warehouse.adres') }}<span
                                        class="text-danger h4">*</span></label>
                                <div v-if="this.edit">
                                    <google-autocomplete @update="getAddress" :ref-create="false"
                                                         :ref-latitude="form.lat"
                                                         :ref-longitude="form.lng"
                                                         :ref-address="form.formatted_address"
                                    >
                                    </google-autocomplete>
                                </div>
                                <div v-else>
                                    <google-autocomplete @update="getAddress" :ref-create="true">
                                    </google-autocomplete>
                                </div>

                            </div>
                            <div class="form-group">
                                <label class="label-item">{{ Lang.get('js.create-warehouse.image') }}</label>
                                <el-file-upload name="pictures"
                                                :quantity="fileUploadSettings.quantity"
                                                :thumbs="thumbs"
                                                :loading="form.loading"
                                                :errors="form.errors"
                                                :delete-url="fileUploadSettings['fileUpload.delete']"
                                                v-model="form.fileUpload.pictures">
                                </el-file-upload>
                            </div>
                            <div class="form-group ckeditor_div">
                                <label class="label-item">Текст<span class="text-danger h4">*</span></label>
                                <div>
                                    <ckeditor :model-name="form.id ? String(form.id) : 'new'"
                                              v-model="form.text"
                                              @input="clearFormErrors('text')">
                                    </ckeditor>
                                    <span class="text-danger"
                                          v-if="form.errors.has('text')"
                                          v-text="form.errors.get('text')">
    </span>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-3 col-12 col-md-6 offset-md-3">
                        <button :disabled="isDisabled"
                                class="btn my-btn type-1"
                                @click="save">
                            {{ Lang.get('js.create-warehouse.save') }}
                        </button>
                        <widget-saving :show="saving" :has-error="form.errors.any()"></widget-saving>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import WidgetSaving from '../elements/WidgetSaving';
    import WidgetLoading from '../elements/WidgetLoading';
    import ElFileUpload from '../../../vendor/FileUpload/js/components/fileUpload.vue';
    import moment from "moment";
    import Ckeditor from '../../../vendor/ckeditor/components/Ckeditor.vue';
    import GoogleAutocomplete from '../GoogleAutocomplete'

    let today = `${new Date().toLocaleDateString()
        .replace(/(\d+).(\d+).(\d+)/i, '$3-$2-$1')} ${new Date().toLocaleTimeString()}`;

    let clearForm = {
        fileUpload: {
            pictures: {},
        },
        id: null,
        translate_id: null,
        name: '',
        area: '',
        price: '',
        measure: '',
        text: '',
        address: '',
        station: '',
        map: '',
        types: [],
        statuses: [],
        title: '',
        link: '',
        user_id: '',
        description: '',
        menu: '',
        created_at: '',
        check_lang: '',
        translate_lang: '',
        lat: '',
        lng: '',
        formatted_address: '',
        language: 'ru',
        premise_type: '',
        floor: '',
        floor_number: '',
        bathroom: '',
        heating: '',
        gas: false,
        central_water_supply: false,
        well: false,
        electricity: false,
        central_sewage_system: false,
        sewerage_septic_tank: false,
        waste_collection: false,
        asphalt_road: false,
        no_communicatio: false,

    };

    export default {
        name: "create-or-edit-premises-by-user",
        components: {
            WidgetSaving,
            WidgetLoading,
            Ckeditor,
            ElFileUpload,
            GoogleAutocomplete
        },
        props: {
            edit: {
                required: true,
            },
            itemData: {
                required: false,
            }, type: {
                required: false,
            },
            userId: {
                required: false,
            },
            defItemType: {
                required: false,
            },
            reload: {
                required: false,
                type: Boolean,
            },
            typesForPreview: {
                required: false
            },
            itemDataPremiseStatuses: {
                required: false
            },
            statusesForPreview: {
                required: false
            },
            languagesList: {
                required: false
            },
            multiLanguage: {
                required: false,
            },
            defaultLanguage: {
                required: false,
            },
            chooseLanguage: {
                required: false,
            }
        },
        data() {
            return {
                form: new Form(clearForm),
                premiseTypesList: premiseTypes,
                premiseStatusesList: premiseStatuses,
                preparedStationTypes: [],
                preparedBathroomTypes: '',
                preparedHeatingTypes: '',
                promise: {},
                thumbs: [],
                item: {},
                itemType: '',
                selectPlaceholder: 'Выберите тип',
                statusPlaceholder: 'Выберите статус',
                saving: false,
                loading: true,
                currentSeo: {},
                translateName: '',
                fileUploadSettings: {
                    quantity: 10,
                    'fileUpload.delete': '/file-upload/delete',
                },
                isDisabled: false,
                selectLanguage: '',
                Lang,
                type_options_ua: [
                    {
                        id: 1,
                        value: 'Продаж',
                    },
                    {
                        id: 2,
                        value: 'Аренда',
                    },
                ],
                type_options_ru: [
                    {
                        id: 1,
                        value: 'Продажа',
                    },
                    {
                        id: 2,
                        value: 'Аренда',
                    },
                ],
            }
        },
        computed: {
            premiseTypeOptions() {
              if (Lang.locale == 'ua') {
                  return this.type_options_ua;
              } else {
                  return this.type_options_ru;
              }
            },
            preparedPremiseTypes() {
                let filteredTypes = this.premiseTypesList;
                console.log(filteredTypes);
                return filteredTypes.filter(item => item.language === this.defaultLanguage);

            },
            preparedPremiseStatuses() {
                let filteredStatuses = this.premiseStatusesList;
                return filteredStatuses.filter(item => item.language === this.defaultLanguage);
            },
        },
        watch: {
            defItemType(newVal, oldVal) {
                this.itemType = newVal;
                this.setScenario();
            },
            chooseLanguage(newVal, oldVal) {
                this.selectLanguage = newVal;
                this.setScenario();
            },
        },
        methods: {
            getAddress(data) {
                this.form.lat = data.lat;
                this.form.lng = data.lng;
                this.form.formatted_address = data.formatted_address;
            },
            getTranslatedTypes(types) {
                if (this.itemType === 'translate') {
                    let langType = this.premiseTypesList.find(item => +item.id === +id);
                    let translateId = this.premiseTypesList.filter(item => +item.translate_id === +langType.translate_id);

                    let langTypeId = '';

                    langTypeId = translateId.find(item => item.language === this.getTranslateLanguage);

                    if (langTypeId) {
                        return langTypeId.id;
                    } else {
                        this.selectPlaceholder = 'Тип "' + langType.name + '" не переведен';
                        return null;
                    }
                } else {
                    let typesList = [];
                    types.forEach((item) => {
                        typesList.push(item.id);
                    });
                    return typesList;
                }
            },

            getTranslatedStatuses(statuses) {
                if (this.itemType === 'translate') {
                    let langStatus = this.premiseStatusesList.find(item => +item.id === +id);
                    let translateId = this.premiseStatusesList.filter(item => +item.translate_id === +langStatus.translate_id);

                    let langStatusId = '';

                    langStatusId = translateId.find(item => item.language === this.getTranslateLanguage);

                    if (langStatusId) {
                        return langStatusId.id;
                    } else {
                        this.statusPlaceholder = 'Статус "' + langStatus.name + '" не переведен';
                        return null;
                    }
                } else {
                    let statusesList = [];
                    statuses.forEach((item) => {
                        statusesList.push(+item.id);
                    });
                    return statusesList;
                }
            },

            clearFormErrors(name) {
                this.form.errors.clear(name);
                if (!this.form.errors.any()) {
                    this.isDisabled = false;
                }
            },
            save() {
                this.saving = true;
                this.isDisabled = true;
                let url;
                url = '/premise/store-user';

                if(this.edit) {
                    url = '/premise/update';

                }
                this.form.post(url).then(res => {
                    this.saving = true;
                    if(this.edit) {
                        this.alertSuccess('Тип {name} создан.'.replace('{name}', this.form.name), 6000);
                    } else {
                        this.alertSuccess('Тип {name} обновлён.'.replace('{name}', this.form.name), 6000);
                    }

                    this.isDisabled = false;
                }).catch(rej => console.log(rej));
            },
            alertSuccess(text, time) {
                if (!time) {
                    time = 1500;
                }
                let vm = this;
                swal.fire({
                    position: 'bottom-start',
                    type: 'success',
                    animation: false,
                    title: text,
                    width: 'auto',
                    showConfirmButton: false,
                    timer: time,
                    toast: true,
                }).then((result) => {
                    location.reload();
                });
            },
            changeSelectedPage(newTab) {
                this.currentTab = newTab;
            },
            changeSeo(data) {
                this.form[data.name] = data.value;
            },
            changePublish(data) {
                this.form[data.name] = data.value;
            },
            getData() {
                this.loading = true;
                let url;
                if(Lang.locale == 'ua') {
                    url = '/premise/get-data-page';
                } else {
                    url = '/ru/premise/get-data-page';
                }


                axios.post(url, {}).then(res => {
                    this.preparedBathroomTypes = res.data.bathroom_options;
                    this.preparedHeatingTypes = res.data.heating_options;
                    this.preparedStationTypes = res.data.stations_options;
                    console.log(this.preparedStationTypes);
                    this.loading = false;
                }).catch(rej => console.log(rej));
            },
            setData(data) {
                this.form.id = data['id'];
                this.form.translate_id = data['translate_id'];
                this.form.name = data['name'];
                this.form.area = data['area'];
                this.form.price = +data['price'];
                this.form.address = data['address'];
                this.form.station = +data['station'];
                this.form.measure = data['measure'];
                this.form.text = data['text'];
                this.form.types = data['preperedTypes'];
                this.form.statuses = data['preperedStatuses'];
                this.form.lat = +data['lat'];
                this.form.lng = +data['lng'];
                this.form.premise_type = data['premise_type'];
                this.form.floor = data['floor'];
                this.form.floor_number = data['floor_number'];
                this.form.bathroom = data['bathroom'];
                this.form.heating = data['heating'];
                if(data['gas'] == 0) {
                    this.form.gas = false;
                } else {
                    this.form.gas = true;
                }
                if(data['central_water_supply'] == 0) {
                    this.form.central_water_supply = false;
                } else {
                    this.form.central_water_supply = true;
                }
                if(data['well'] == 0) {
                    this.form.well = false;
                } else {
                    this.form.well = true;
                }
                if(data['electricity'] == 0) {
                    this.form.electricity = false;
                } else {
                    this.form.electricity = true;
                }
                if(data['central_sewage_system'] == 0) {
                    this.form.central_sewage_system = false;
                } else {
                    this.form.central_sewage_system = true;
                }
                if(data['sewerage_septic_tank'] == 0) {
                    this.form.sewerage_septic_tank = false;
                } else {
                    this.form.sewerage_septic_tank = true;
                }
                if(data['waste_collection'] == 0) {
                    this.form.waste_collection = false;
                } else {
                    this.form.waste_collection = true;
                }
                if(data['asphalt_road'] == 0) {
                    this.form.asphalt_road = false;
                } else {
                    this.form.asphalt_road = true;
                }
                if(data['no_communicatio'] == 0) {
                    this.form.no_communicatio = false;
                } else {
                    this.form.no_communicatio = true;
                }
                this.form.no_communicatio = data['no_communicatio'];
                this.form.formatted_address = data['formatted_address'];
                this.form.check_lang = +data['check_lang'];
                this.thumbs = thumbs_js;
                // this.thumbs =  data['thumbs'];

                // this.form.title = data['seo'][0]['title'];
                // this.form.description = data['seo'][0]['description'];
                // this.form.menu = data['seo'][0]['menu'];
                // this.form.link = data['alias']['raw_url'];

                this.form.created_at = data['created_at'];

                // this.currentSeo = {
                //     title: data['seo'][0]['title'],
                //     description: data['seo'][0]['description'],
                //     menu: data['seo'][0]['menu'],
                //     link: data['alias']['raw_url'],
                // };
            },

        },
        mounted() {
            if (this.edit) {

                this.setData(promise_js);
                console.log(promise_js);
            }
            if (this.userId) {
                this.form.user_id = this.userId;
            } else {
                this.form.user_id = 1;
            }
            this.loading = false;
            this.form.language = this.defaultLanguage;
          this.getData();
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/premise/CreateOrEditPremisesByUser.vue